import React from 'react';
import { useNode } from '@craftjs/core';
import { TextField, FormControl, FormLabel, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  form: {
    minHeight: '150px',
    border: '2px dashed #ccc',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#2196f3',
    },
  },
  settings: {
    padding: theme.spacing(2),
  },
}));

export const Form = ({ 
  children, 
  title, 
  backgroundColor, 
  padding, 
  elevation,
  borderRadius
}) => {
  const classes = useStyles();
  const {
    connectors: { connect, drag },
  } = useNode();

  return (
    <Paper
      ref={(ref) => connect(drag(ref))}
      className={classes.form}
      elevation={elevation}
      style={{
        backgroundColor,
        padding: `${padding}px`,
        borderRadius: `${borderRadius}px`,
        width: '100%',
      }}
    >
      {title && (
        <Typography variant="h6" gutterBottom style={{ marginBottom: 16 }}>
          {title}
        </Typography>
      )}
      <form onSubmit={(e) => e.preventDefault()}>
        {children}
      </form>
    </Paper>
  );
};

const FormSettings = () => {
  const classes = useStyles();
  const {
    actions: { setProp },
    title,
    backgroundColor,
    padding,
    elevation,
    borderRadius,
  } = useNode((node) => ({
    title: node.data.props.title,
    backgroundColor: node.data.props.backgroundColor,
    padding: node.data.props.padding,
    elevation: node.data.props.elevation,
    borderRadius: node.data.props.borderRadius,
  }));

  return (
    <div className={classes.settings}>
      <FormControl fullWidth margin="normal">
        <FormLabel>Título del formulario</FormLabel>
        <TextField
          value={title}
          onChange={(e) => setProp((props) => (props.title = e.target.value))}
          placeholder="Opcional"
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Color de fondo</FormLabel>
        <TextField
          type="color"
          value={backgroundColor}
          onChange={(e) => setProp((props) => (props.backgroundColor = e.target.value))}
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Padding (px)</FormLabel>
        <TextField
          type="number"
          value={padding}
          onChange={(e) => setProp((props) => (props.padding = e.target.value))}
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Elevación (sombra)</FormLabel>
        <TextField
          type="number"
          inputProps={{ min: 0, max: 24 }}
          value={elevation}
          onChange={(e) => setProp((props) => (props.elevation = parseInt(e.target.value)))}
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Radio del borde (px)</FormLabel>
        <TextField
          type="number"
          value={borderRadius}
          onChange={(e) => setProp((props) => (props.borderRadius = e.target.value))}
        />
      </FormControl>
    </div>
  );
};

Form.craft = {
  props: {
    title: 'Formulario de Contacto',
    backgroundColor: '#ffffff',
    padding: 24,
    elevation: 2,
    borderRadius: 8,
  },
  related: {
    settings: FormSettings,
  },
};
